<div class="PGRecipient">
    <div class="input-group">
        <input class="form-control"
            [attr.id]="id || null"
            [attr.aria-label]="ariaLabel || null"
            [attr.aria-describedby]="via ? ('pg-recipient-via-' + (id || 'default')) : null"
            [disabled]="readonly"
            [placeholder]="disablePhone ? 'email@website.com' : ('pg-recipient.placeholder' | locTranslate)"
            [(ngModel)]="value"
            (ngModelChange)="onRecipientChange()"
            autocomplete="email"
            inputmode="email"/>
        @if (!readonly && !disablePhone) {
            <div class="input-group-text" [attr.id]="'pg-recipient-via-' + (id || 'default')" [attr.title]="via == 'phone' ? ('pg-recipient.via-sms' | locTranslate) : via == 'email' ? ('pg-recipient.via-email' | locTranslate) : ''" [attr.aria-label]="via == 'phone' ? ('pg-recipient.via-sms' | locTranslate) : via == 'email' ? ('pg-recipient.via-email' | locTranslate) : null">
                @if (via == null) {
                    <small aria-hidden="true">-</small>
                }
                @if (via == 'phone') {
                    <small>
                        <b>SMS</b>
                    </small>
                }
                @if (via == 'email') {
                    <i class="fa-regular fa-at" aria-hidden="true"></i>
                }
            </div>
        }
    </div>
</div>
